var map = {
	"./404.svg": 95450,
	"./add.svg": 33166,
	"./btn4.svg": 94873,
	"./edit.svg": 32654,
	"./export.svg": 50097,
	"./eye-close.svg": 84981,
	"./eye.svg": 80316,
	"./import.svg": 38223,
	"./remove.svg": 63057,
	"./return.svg": 83065,
	"./setting.svg": 4447,
	"./show.svg": 27293,
	"./work.svg": 12536,
	"./删除.svg": 57608,
	"./新增.svg": 39005
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79253;